export function getUserRoles(user: any): string[] {
  if (Array.isArray(user?.roles)) {
    return user.roles
  }

  if (Array.isArray(user?.activeClient?.roles)) {
    return user.activeClient.roles
  }

  return []
}

export function hasAnyUserRole(user: any, roles: string[]) {
  return getUserRoles(user).some((role: string) => roles.includes(role))
}

export function getUserStateAbbreviation(user: any): string | null {
  if (typeof user?.stateAbbreviation === 'string' && user.stateAbbreviation) {
    return user.stateAbbreviation
  }

  const preferredGeneralSettings = user?.activeClient?.settings?.general
  if (
    preferredGeneralSettings?.preferredSpaceDelimitationType === 'state' &&
    typeof preferredGeneralSettings?.preferredSpaceDelimitationTitle === 'string' &&
    preferredGeneralSettings.preferredSpaceDelimitationTitle
  ) {
    return preferredGeneralSettings.preferredSpaceDelimitationTitle
  }

  return null
}
